import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TemplateVisitorCardAddComponent } from './template-visitor-card_add.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [TemplateVisitorCardAddComponent],
  exports: [
    TemplateVisitorCardAddComponent
  ],
  providers: [
  ]
})
export class TemplateVisitorCardAddModule { }
